import * as React from 'react';
import * as styles from '../users.module.scss';
import User, { UserOktaStatus } from '../../../../models/user';
import { withRouter, RouteComponentProps } from 'react-router';
import TertiaryButton from '../../../common/tertiary-button';
import Paths from '../../../../models/enums/paths';
import useUser from '../../../../hooks/useUser';

interface Props extends RouteComponentProps {
  user: User;
  setErrorMessage: (message: string) => void;
  setSuccessMessage: (message: string) => void;
}

/**
 * UserEntry
 * @function UserEntry
 */
const UserEntry = ({ user, setErrorMessage, setSuccessMessage, history }: Props) => {
  const { inviteUser } = useUser();

  const redirectToEditUserId = (userId) => {
    history.push(Paths.EditUser.replace(':userId', userId.toString()));
  };

  const handleInvite = () => {
    inviteUser(user)
      .then((response) => {
        if (response.success) {
          setSuccessMessage(response.message);
        } else {
          setErrorMessage(response.message);
        }
      })
      .catch((err) => {
        setErrorMessage(err.responseJSON.message);
      });
  };

  return (
    <tr>
      <td>
        {user.lastName}, {user.firstName}
      </td>
      <td>{user.role}</td>
      <td className={styles.emailCol} title={user.email}>
        {user.email}
      </td>
      <td title={user.department}>{user.department}</td>
      <td>{UserOktaStatus[user.status] ?? 'Unknown'}</td>
      <td>
        <TertiaryButton text="Edit User" title="Edit User" handleClick={() => redirectToEditUserId(user.id)} />
      </td>
      <td>
        <TertiaryButton text="Invite User" title="Invite User" handleClick={handleInvite} />
      </td>
    </tr>
  );
};

export default withRouter(UserEntry);
